import React from 'react';
import styled from 'styled-components';

export const Label = ({
  children,
  ...props
}: React.PropsWithChildren<React.LabelHTMLAttributes<HTMLLabelElement>>) => (
  <Container {...props}>{children}</Container>
);

const Container = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.color.text.disabled};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  margin: 8px 0;
`;
